import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M10 1a8.978 8.978 0 0 0-6.708 3A8.967 8.967 0 0 0 1 10c0 2.305.867 4.408 2.292 6A8.978 8.978 0 0 0 10 19a8.97 8.97 0 0 0 6.225-2.5A8.974 8.974 0 0 0 19 10a8.97 8.97 0 0 0-2.5-6.225A8.974 8.974 0 0 0 10 1Zm0 4a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 5Zm0 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 10Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgInfoFill);
export { ForwardRef as ReactComponent };
